import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Agent, BreadcrumbService, AgentsService, UtilsService, PopUpService } from '../../core';
import { MatTabGroup } from '@angular/material/tabs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-agent-detail',
  templateUrl: './agent-detail.component.html',
  styleUrls: ['./agent-detail.component.scss']
})
export class AgentDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  public agent: Agent;
  public config: any;
  public tabsManager: any | Subscription = new Subscription();
  public agentEmailsListId = 'AGENT_EMAILS_LIST';
  public agentClientslistId = 'AGENT_CLIENTS_LIST';
  public agentGroupslistId = 'AGENT_GROUPS_LIST';
  public timezone: any;
  @ViewChild('tabGroup', { static: false }) public tabGroup: MatTabGroup;

  public filters: Object;
  public rolesConfig = {
    csAdmin: {
      clients: true,
      groups: true
    },
    csm: {
      clients: true,
      groups: true
    },
    supportSpecialist: {
      clients: true,
      groups: true
    },
    sales: {
      clients: true,
      groups: true
    },
    distributorManager: {
      clients: false,
      groups: false
    },
    distributor: {
      clients: false,
      groups: false
    },
    clientAdmin: {
      clients: false,
      groups: true
    },
    hr: {
      clients: false,
      groups: true
    }
  };

  constructor(
    public agentsService: AgentsService,
    public route: ActivatedRoute,
    public location: Location,
    public router: Router,
    public titleService: Title,
    public translate: TranslateService,
    public breadcrumb: BreadcrumbService,
    public popupService: PopUpService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.agent = data['agent'];
      this.config = this.rolesConfig[this.agent.role] || { clients: false, groups: false };
      this.filters = { entityId: this.agent.id };
      this.titleService.setTitle(
        (this.agent.name ? this.agent.name : this.agent.id) +
          ' - ' +
          this.translate.instant('pageTitle.agents') +
          ' - ' +
          this.translate.instant('pageTitle.gamelearn')
      );
      this.timezone = data.client?.timezone || this.agent.timezone;
    });
  }

  public ngAfterViewInit(): void {
    this.tabsManager = UtilsService.createTabsManager(this.route, this.tabGroup);
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.tabsManager.unsubscribe();
  }

  goBack(): void {
    this.location.back();
  }

  onUpdateAgent(agent: Agent): void {
    this.agent = agent;
  }

  deleteAgent(): void {
    this.popupService
      .showConfirm({
        title: this.translate.instant('agents.confirmDelete', { agent: this.agent.name }),
        text: this.translate.instant('agents.deleteMessage')
      })
      .then(() => this.agentsService.delete(this.agent.id))
      .then(() => this.router.navigate(['/agents']))
      .catch(() => {});
  }

  public noDeleteAgent(): void {
    this.popupService
      .showError({
        title: this.translate.instant('agents.deleteAgentError', { agent: this.agent.name })
      })
      .then();
  }
}
